import React from 'react';
import { ChevronIcon, CheckIcon } from '../../../shared/filterUtils';

/**
 * KanbanFilterSection Component
 * 
 * Collapsible section header for filter groups (Status, Priority, etc.)
 */
export const KanbanFilterSection = ({ 
  title, 
  sectionId, 
  expandedSections, 
  toggleSection, 
  count, 
  children 
}) => (
  <div className="kanban-filter-dropdown__section">
    <button 
      className="kanban-filter-dropdown__section-header" 
      onClick={() => toggleSection(sectionId)}
    >
      <span className="kanban-filter-dropdown__section-title">{title}</span>
      {count > 0 && <span className="kanban-filter-dropdown__section-count">{count}</span>}
      <span className={`kanban-filter-dropdown__section-chevron ${expandedSections.has(sectionId) ? 'kanban-filter-dropdown__section-chevron--open' : ''}`}>
        <ChevronIcon />
      </span>
    </button>
    {expandedSections.has(sectionId) && (
      <div className="kanban-filter-dropdown__options">
        {children}
      </div>
    )}
  </div>
);

/**
 * KanbanFilterOption Component
 * 
 * Individual filter option with checkbox, color indicator, and label
 */
export const KanbanFilterOption = ({ 
  label, 
  color, 
  checked, 
  onChange, 
  isTag = false 
}) => (
  <label className="kanban-filter-dropdown__option">
    <span className="kanban-filter-dropdown__option-check">
      {checked && <CheckIcon />}
    </span>
    <span 
      className={`kanban-filter-dropdown__option-color ${isTag ? 'kanban-filter-dropdown__option-color--tag' : ''}`} 
      style={{ backgroundColor: color }} 
    />
    <span className="kanban-filter-dropdown__option-label">{label}</span>
    <input 
      type="checkbox" 
      checked={checked || false} 
      onChange={onChange} 
      className="kanban-filter-dropdown__option-input" 
    />
  </label>
);
